import {
    Component,
    ElementRef,
    Input,
    AfterViewInit,
    ViewChild,
    OnChanges,
    SimpleChanges
} from "@angular/core";
import {DecimalPipe} from "@angular/common";

@Component({
    selector: "animated-digit",
    templateUrl: "animated-digit.component.html",
    styleUrls: ["animated-digit.component.scss"],
    standalone: false
})
export class AnimatedDigitComponent implements AfterViewInit, OnChanges {
    @Input() duration: number = 1000;
    @Input() digit;
    @Input() formatDecimal: string = '1.0-0';
    @Input() steps: number;
    _isFormatDecimal = true;
    @Input() set isFormatDecimal(value){
        this._isFormatDecimal = value == 'true';
    }
    @ViewChild('animatedDigit') animatedDigit: ElementRef;

    constructor(private _decimalPipe: DecimalPipe, private host: ElementRef ) {
    }

    animateCount() {
        if (typeof this.digit !== "number") {
            this.digit = Number(this.digit);
            this.duration = Number(this.duration);
        }
        this.counterFunc(this.digit, this.duration, this.animatedDigit, this._decimalPipe, this._isFormatDecimal?this.formatDecimal:null);
    }

    counterFunc(endValue, durationMs, element, decimalPipe, format) {
        if (!this.steps) {
            this.steps = 12;
        }
        const stepCount = Math.abs(durationMs / this.steps);
        const valueIncrement = (endValue - 0) / stepCount;
        const sinValueIncrement = Math.PI / stepCount;

        let currentValue = 0;
        let currentSinValue = 0;

        function step() {
            currentSinValue += sinValueIncrement;
            currentValue += valueIncrement * Math.sin(currentSinValue) ** 2 * 2;
            if (element)
                element.nativeElement.textContent = Math.abs(Math.floor(currentValue));

            if (currentSinValue < Math.PI) {
                window.requestAnimationFrame(step);
            } else {
                if (element)
                    element.nativeElement.textContent = format ? decimalPipe.transform(endValue, format): endValue;
            }
        }
        step();
    }

    ngAfterViewInit() {
        // trigger animation only when the animated element appears on screen
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if(entry.isIntersecting && this.digit) {
                    this.animateCount();
                }
            })
        },
            {
                threshold: .5,
            });
        observer.observe(this.host.nativeElement);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["digit"]) {
            this.animateCount();
        }
    }
}
